// Lib
import React from 'react';
import { Check } from 'lucide-react';

// Components
import { GoalsSelector } from '../components/GoalsSelector';
import { Input } from '@components/ui/input';
import { Textarea } from '@components/ui/textarea';
import { cn } from '@components/lib/utils';

// Types
import type {
  OrganizationAnswers,
  OrganizationErrors,
} from '../../model/useCreateOrganization';

interface GoalsStepProps {
  answers: OrganizationAnswers;
  onChange: (name: string, value: string | string[]) => void;
  error: OrganizationErrors;
  onSetError?: (name: string, value: string) => void;
}

export const GoalsStep: React.FC<GoalsStepProps> = ({
  answers,
  onChange,
  error,
  onSetError,
}) => {
  const ownActive = Boolean(answers?.goalsOwn);

  return (
    <>
      <h1 className="mb-8 text-center text-2xl font-bold tracking-tight text-foreground">
        What are your goals?
      </h1>
      <GoalsSelector answers={answers} onChange={onChange} />
      <div className="relative mb-10 w-full">
        {ownActive && (
          <div className="absolute -right-1 -top-1 z-[1] flex size-4 items-center justify-center rounded-full bg-marble-blue-400">
            <Check className="size-3 text-white" />
          </div>
        )}
        <Input
          type="text"
          name="goalsOwn"
          placeholder="Enter your own"
          aria-invalid={Boolean(error?.goalsOwn)}
          className={cn(
            ownActive && 'border-marble-blue-400 bg-marble-blue-50',
          )}
          onChange={(field) => onChange('goalsOwn', field.target.value)}
          value={answers?.goalsOwn}
        />
      </div>
      <p className="mb-2 text-center text-sm font-medium text-foreground">
        What else should we know?
      </p>
      <Textarea
        value={answers?.extraInfo}
        onChange={(e) => {
          if (error?.extraInfo && onSetError) onSetError('extraInfo', '');
          onChange('extraInfo', e.target.value);
        }}
        placeholder="Tell us about your company"
      />
    </>
  );
};
